import DateSelect from './DateSelect'
import TimeSelect from './TimeSelect'
import moment from 'moment'

export default {
	name: 'DateCondition',
	components: {
		DateSelect,
		TimeSelect
	},
	props: {
		value: {
			type: Object
		}
	},
	data () {
		return {
			val: { ...this.value }
		}
	},
	template: `
		<dl class="search-data -sp-no-left">
			<dt class="search-data__ttl-left">日時指定<span class="search-data__sp-while">~</span></dt>
			<dd>
				<div class="m-sch -sp-size-s">
					<DateSelect v-model="val.dateFrom"
						@input="inputDateFrom"
						@controlClick="$emit('controlClick')"
					/>
					<TimeSelect v-model="val.timeFrom"
						@input="fireInput"
						@controlClick="$emit('controlClick')"
					/>
				</div>
				<span class="search-data__while">~</span>
				<div class="m-sch -sp-size-s">
					<DateSelect v-model="val.dateTo"
						:min="val.dateFrom"
						@input="inputDateTo"
						@controlClick="$emit('controlClick')"
					/>
					<TimeSelect v-model="val.timeTo"
						@input="fireInput"
						@controlClick="$emit('controlClick')"
					/>
				</div>
			</dd>
		</dl>
	`,
	methods: {
		inputDateFrom () {
			const { val } = this
			if (val.dateFrom && !val.dateTo) {
				val.dateTo = val.dateFrom
			}
			if (!val.timeFrom) {
				val.timeFrom = '9:00'
				val.timeTo = '10:00'
			}
			if (val.dateTo && moment(val.dateFrom).isAfter(val.dateTo)) {
				val.dateTo = val.dateFrom
			}
			this.fixTimeRestriction()
			this.fireInput()
		},
		inputDateTo () {
			this.fixTimeRestriction()
			this.fireInput()
		},
		fixTimeRestriction () {
			// TODO: 時間の制限をいいがにする
		},
		fireInput () {
			this.$emit('input', this.val)
		}
	}
}
